import { render, staticRenderFns } from "./TowerItem.vue?vue&type=template&id=67b1bc52&scoped=true&"
import script from "./TowerItem.vue?vue&type=script&lang=js&"
export * from "./TowerItem.vue?vue&type=script&lang=js&"
import style0 from "./TowerItem.vue?vue&type=style&index=0&id=67b1bc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1bc52",
  null
  
)

export default component.exports